<div mat-dialog-content>
  <pcp-period-selection
    [(value)]="data"
    (valueChange)="valueChanged()"
  ></pcp-period-selection>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data" i18n>Ok</button>
</div>
